import { IonIcon } from '@ionic/react'
import React from 'react'

import { ENodeVehicle } from '@vae/server/src/interfaces/eNode/eNodeVehicle.interface'
import { checkmarkCircle, pause, play } from 'ionicons/icons'
import { useTranslation } from 'react-i18next'
import { SmartChargeOverrideHook } from '../hooks/useSmartChargeOverride'

interface Props {
	smartOverride: SmartChargeOverrideHook
	vehicle: ENodeVehicle | null | undefined
	isError: boolean
	chargingState?: string
}
const ChargingState: React.FC<Props> = ({ smartOverride, vehicle, isError }) => {
	const { t } = useTranslation('pages_electricCar')

	return (
		<div>
			{smartOverride?.isCharging || vehicle?.chargeState.isCharging ? (
				<div className='flex flex-row gap-2 items-center justify-center'>
					{t('electricCarDetail.latausKaynnissa')}
					<IonIcon icon={play} />
				</div>
			) : (
				<div className='flex flex-col gap-1 items-center'>
					<div className='flex flex-col gap-1 items-center'>
						{vehicle?.chargeState.isFullyCharged ? (
							<IonIcon className='checkmark' icon={checkmarkCircle} />
						) : (
							<IonIcon icon={pause} />
						)}
						{vehicle?.chargeState.isFullyCharged && t('electricCarDetail.latausrajaSaavutettu')}
						{isError && t('electricCarDetail.latausVirhe')}
					</div>
				</div>
			)}
		</div>
	)
}

export default ChargingState
